import React, {Component} from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';
import Modal from '../Modal';
import {changeToTrial} from '../../actions/ClientActions';
import moment from 'moment-timezone';

@connect()

export default class ChangeEssentialsAndProTrialPlanModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            currentTrialPlan : props.client.currentPlan
        }
    }

    changeToTrial(){
        return this.props.dispatch(
            changeToTrial(
                {
                    clientId : this.props.client.id,
                    trialEnd: this.props.client.trialExpiresAt,
                    planName: this.state.currentTrialPlan.label,
                    skipCurrentPlanCheck: this.props.client.availablePlansToChangeFromLegacy.length > 0
                }
            )
        );
    }

    handlePlanChange(value){

        this.setState({
            currentTrialPlan : value
        });
    }

    render() {
        var actionButton = <button className="btn btn-success" onClick={this.changeToTrial.bind(this)}>Save</button>
        return (
            <Modal actionButton={actionButton} className="modal modal-success" title={"Trial Plan Type"}>
                <Select
                    placeholder="Trial Plan Type..."
                    multi={false}
                    value={this.state.currentTrialPlan}
                    options={this.props.client.essentialsAndProTrialPlans}
                    onChange={this.handlePlanChange.bind(this)}
                />
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/ChangeEssentialsAndProTrialPlanModal.js